export default (requests) => {
    return {
        getCmsPage: (page) => {
            return requests.get('/cms/pages/' + page + '/content');
        },  
    }
};
